<template lang="pug">
  div.container-fluid.animated.fadeIn
    nav(aria-label="breadcrumb")
      b-breadcrumb
        b-breadcrumb-item
          router-link(to="/configuration")
            i.fa.fa-cogs
            span.ml-1 {{ $t("ui.configuration") }}
        b-breadcrumb-item
          router-link(to="/configuration/provider")
            i.fa.fa-sitemap
            span.ml-1 {{ $tc("ui.providers", 2) }}
    div.row.mb-5
      div.col-md-12
        div.card
          div.card-header
            div.row
              div.col-md-12.mb-1
                div.form-row
                  div.col-sm-9.col-md-6.mb-1
                    b-input-group(size="sm")
                      b-input-group-text(slot="prepend")
                        i.icon-magnifier
                      DebounceInput(required autofocus type="text" v-model="providerSearch" :placeholder="$t('message.search_by_id_name')")
                  div.col-sm-3.col-md-1.mb-1
                    b-form-radio-group(
                      buttons
                      v-model="filterBy"
                      size="sm"
                      button-variant="outline-info"
                    )
                      b-form-radio(value="id") {{ $t("ui.id") }}
                      b-form-radio(value="name") {{ $t("ui.name") }}
              div.col-md-12
                b-button(v-b-modal.addProvider type="button" variant="primary" size="sm").mr-1
                  i.fa.fa-plus
                  span {{ $t("ui.combine.add_provider") }}
          div.card-body.p-1.clusterize
            .clusterize-scroll
              table.tablex(style="width: auto;" v-columns-resizable)
                thead
                  tr
                    th.sticky-position
                      span {{ $t('ui.id') }}
                    th.text-center.sticky-position(width=100)
                      span {{ $t("ui.action") }}
                    th.text-center.sticky-position(width=100 style="z-index: 10;")
                      span {{ $t("ui.disabled") }}
                    th.sticky-position
                      span {{ $t("ui.name") }}
                    th.text-right.sticky-position(width=200)
                      span {{ $t("ui.created_on") }}
                tbody.clusterize-content
                  tr(v-for="(item, index) in filteredProviderList")
                    td
                      span {{ item.provider_id }}
                    td.actions
                      span
                        a.fa.fa-edit.text-primary(href="#" @click="onEdit(item)" :title="$t('ui.edit')")
                      span
                        a.fa.fa-trash.text-danger(href="#" @click="onDelete(item)" :title="$t('ui.delete')")
                    td.actions
                      div.d-flex.justify-content-center.align-items-center
                        label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                          input.switch-input(type="checkbox" v-model="item.provider_disabled" @change="changedDisable(item, $event)")
                          span.switch-slider(:data-checked='on' :data-unchecked='off')
                    td
                      span {{ item.provider_name }}
                    td.text-right
                      span {{ $moment(item.created_on).format("YYYY-MM-DD, HH:mm:ss") }}
      addprovider(@clicked="addProvider" @failed="handleFailed")
      editprovider(ref="editprovider" :providerId="editSelectedId" :providerName="editSelectedName" @clicked="editProvider" @failed="handleFailed")
      deleteprovider(ref="deleteprovider" :providerId="deleteSelectedId" :providerName="deleteSelectedName" @clicked="deleteProvider" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import addprovider from "@/components/provider/addProvider.vue";
import editprovider from "@/components/provider/editProvider.vue";
import deleteprovider from "@/components/provider/deleteProvider.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    addprovider,
    editprovider,
    deleteprovider,
    DebounceInput
  },
  data() {
    return {
      filterBy: "id",
      providerList: [],
      providerSearch: "",
      feedback: {
        success: false,
        status: errorTags.request.failed
      },
      editSelectedId: "",
      editSelectedName: "",
      deleteSelectedId: "",
      deleteSelectedName: ""
    };
  },
  computed: {
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    filteredProviderList() {
      return this.providerList.filter(item => {
        if (this.filterBy == "name") {
          return item.provider_name.toLowerCase().indexOf(this.providerSearch.toLowerCase()) > -1;
        } else {
          return item.provider_id.toLowerCase().indexOf(this.providerSearch.toLowerCase()) > -1;
        }
      });
    }
  },
  mounted: function() {
    let url = config.providerListUrl();

    var json = {
      action_by: this.$store.getters.username,
      session_token: this.$store.getters.sessionToken,
      page_id: config.accessRoles.provider
    };

    this.$http.post(url, json).then(
      function(response) {
        // Success
        try {
          if (response) {
            if (typeof response.data.status == "string") {
              this.feedback.success = response.data.status == "1";
            } else {
              this.feedback.success = response.data.status == 1;
            }
            this.feedback.status = response.data.statusdesc;
            if (this.feedback.success == true) {
              this.providerList = response.data.tbl_provider_list;
            } else {
              this.$helpers.handleFeedback(this.feedback.status);
            }
          }
        } catch (error) {
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      },
      function(response) {
        // Error
        this.feedback.success = false;
        this.feedback.status = errorTags.request.failed;
        this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
      }
    );
  },
  methods: {
    changedDisable: function(disabled, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.disabled"),
          text: this.$t("message.change_disable_confirm", { name: disabled.provider_name }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.submit(disabled, eventStatus.srcElement.checked);
          } else {
            eventStatus.srcElement.checked = !disabled.provider_disabled;
          }
        });
    },
    submit: function(disabled, status) {
      let url = config.editProviderDisabledUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.provider,
        provider_id: disabled.provider_id,
        provider_disabled: status
      };

      this.feedback.success = true;
      // this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          // this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                disabled.provider_disabled = status;
                this.$helpers.showDialog(this.$t("ui.disabled"), this.$t("message.success"), "success");
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    onEdit(e) {
      this.editSelectedId = e.provider_id;
      this.editSelectedName = e.provider_name;
      this.$refs.editprovider.$refs.editProvider.show();
    },
    onDelete(e) {
      this.deleteSelectedId = e.provider_id;
      this.deleteSelectedName = e.provider_name;
      this.$refs.deleteprovider.$refs.deleteProvider.show();
    },
    addProvider: function(providerId, providerName) {
      let newProvider = {
        provider_id: providerId.toUpperCase(),
        provider_name: providerName,
        created_on: new Date()
      };

      this.providerSearch = "";
      this.providerList.unshift(newProvider);
      this.$helpers.showDialog(this.$t("ui.combine.add_provider"), this.$t("message.success"), "success");
    },
    editProvider: function(providerId, providerName) {
      this.providerList.filter(function(providerInfo) {
        if (providerInfo.provider_id == providerId) {
          providerInfo.provider_name = providerName;
        }
      });
      this.$helpers.showDialog(this.$t("ui.combine.edit_provider"), this.$t("message.success"), "success");
    },
    deleteProvider: function(providerId) {
      let i = this.providerList
        .map(providerInfo => {
          return providerInfo.provider_id;
        })
        .indexOf(providerId);
      this.providerList.splice(i, 1);
      this.$helpers.showDialog(this.$t("ui.combine.delete_provider"), this.$t("message.success"), "success");
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
